import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterCard?: string;
}

export function SEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage = 'https://stopsomesquadrias.com.br/og-image.jpg',
  twitterCard = 'summary_large_image',
}: SEOProps) {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper to update or create meta tags
    const updateMetaTag = (selector: string, attribute: string, value: string) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      } else {
        // Create if it doesn't exist (though they should be in index.html)
        if (selector.startsWith('meta[name=')) {
          const name = selector.match(/name="([^"]+)"/)?.[1];
          if (name) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', name);
            meta.setAttribute(attribute, value);
            document.head.appendChild(meta);
          }
        } else if (selector.startsWith('meta[property=')) {
          const property = selector.match(/property="([^"]+)"/)?.[1];
          if (property) {
            const meta = document.createElement('meta');
            meta.setAttribute('property', property);
            meta.setAttribute(attribute, value);
            document.head.appendChild(meta);
          }
        }
      }
    };

    updateMetaTag('meta[name="description"]', 'content', description);
    updateMetaTag('meta[property="og:title"]', 'content', ogTitle || title);
    updateMetaTag('meta[property="og:description"]', 'content', ogDescription || description);
    updateMetaTag('meta[property="og:image"]', 'content', ogImage);
    updateMetaTag('meta[property="og:url"]', 'content', ogUrl || window.location.href);
    updateMetaTag('meta[name="twitter:title"]', 'content', ogTitle || title);
    updateMetaTag('meta[name="twitter:description"]', 'content', ogDescription || description);
    updateMetaTag('meta[name="twitter:image"]', 'content', ogImage);
    updateMetaTag('meta[name="twitter:card"]', 'content', twitterCard);

  }, [title, description, ogTitle, ogDescription, ogUrl, ogImage, twitterCard]);

  return null;
}
